import type * as React from "react";

import { NavAgents } from "./nav-agents";
import { NavWorkflows } from "./nav-workflows";
import { NavTasks } from "./nav-tasks";
import { NavSecondary } from "./nav-secondary";
import { SidebarUserNav } from "@/components/sidebar-user-nav";

// import { NavUser } from "./nav-user" // Commenting this out as User type will be defined locally
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

// The following User interface is removed
// interface User {
// name: string;
// email: string;
// avatar: string;
// }

const data = {
  user: {
    name: "eunice@asepha.ai",
    email: "Asepha Health",
    avatar: "/images/asepha-icon.jpeg",
  },
};

// Simple user type for React app
interface User {
  uid?: string;
  email?: string | null;
  displayName?: string | null;
  photoURL?: string | null;
}

export function AppSidebar({
  user,
  onNavigate,
  activePage,
  ...props
}: {
  user?: User;
  onNavigate: (page: string) => void;
  activePage: string;
} & React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              className="data-[slot=sidebar-menu-button]:!p-1.5"
            >
              <a href="#" className="flex items-center gap-2">
                <div className="group-data-[collapsible=icon]:hidden">
                  <img
                    src="/images/asepha-logo.png"
                    alt="Asepha Logo"
                    width={120}
                    height={30}
                    className="h-auto"
                  />
                </div>
                <div className="hidden group-data-[collapsible=icon]:block">
                  <img
                    src="/images/logo_icon.png"
                    alt="Asepha Icon"
                    width={30}
                    height={30}
                    className="h-auto"
                  />
                </div>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent className="flex flex-col">
        <div className="flex-none">
          <NavAgents onNavigate={onNavigate} activePage={activePage} />
          <div className="mx-2 my-0.5 h-px bg-gray-200 dark:bg-gray-800 group-data-[collapsible=icon]:mx-auto group-data-[collapsible=icon]:my-0.5 group-data-[collapsible=icon]:h-px group-data-[collapsible=icon]:w-4/5"></div>
          <NavWorkflows onNavigate={onNavigate} activePage={activePage} />
          <div className="mx-2 my-0.5 h-px bg-gray-200 dark:bg-gray-800 group-data-[collapsible=icon]:mx-auto group-data-[collapsible=icon]:my-0.5 group-data-[collapsible=icon]:h-px group-data-[collapsible=icon]:w-4/5"></div>
          <NavTasks onNavigate={onNavigate} activePage={activePage} />
        </div>
        <div className="flex-1"></div>
        <NavSecondary onNavigate={onNavigate} activePage={activePage} />
      </SidebarContent>
      <SidebarFooter>
        <SidebarUserNav user={user} />
      </SidebarFooter>
    </Sidebar>
  );
}
